import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export const usePayGroups = () => {
  const [payGroups, setPayGroups] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${API}/api/employees/pay-groups`, { headers })
      .then(r => setPayGroups(r.data || []))
      .catch(() => setPayGroups([]))
      .finally(() => setLoading(false));
  }, []);

  return { payGroups, loading };
};
